import { configureStore } from "@reduxjs/toolkit";
import mainDataReducer from "./slices/mainDataSlice";

export const store = configureStore({
  reducer: {
    main: mainDataReducer,
  },
});
